import ArticlesPage, { getStaticProps as defaultGetStaticProps } from '..'

export const getStaticPaths = async () => ({
  paths: [],
  fallback: 'blocking',
})

export const getStaticProps = defaultGetStaticProps

export default ArticlesPage
